import { Button } from "primereact/button";
import { ImovelType, PlanoType, STATUS } from "../../db/Orm";
import CadastroPlantio, { CadastroPlantioConfig } from "../dialogs/CadastroPlantio";
import { useState } from "react";

enum STATUS_ANTECIPACAO {
    CRIADO,
    PLANTIO_CADASTRADO_PRODUTOR,
    PLANTIO_APROVADO_RT,
    PLANTIO_REPROVADO_RT,
    PLANTIO_APROVADO_AIBA,
    PLANTIO_REPROVADO_AIBA,
    CONTROLE_CADASTRADO_RT,
    CONTROLE_APROVADO_AIBA,
    CONTROLE_REPROVADO_AIBA,
    CONTROLE_ASSINADO_PRODUTOR,
    PLANO_APROVADO_ADAB,
    PLANO_REPROVADO_ADAB
}

type AntecipacaoProps = {
    antecipacao: PlanoType,
    propriedades: ImovelType[]
}

export const estado = (antecipacao: PlanoType): STATUS_ANTECIPACAO => {
    if (antecipacao.controles_status !== STATUS.NOVO) {
        if (antecipacao.controles_status === STATUS.APROVADO)
            return STATUS_ANTECIPACAO.PLANO_APROVADO_ADAB
        return STATUS_ANTECIPACAO.PLANO_REPROVADO_ADAB
    }
    else if (antecipacao.controles_assinado_produtor)
        return STATUS_ANTECIPACAO.CONTROLE_ASSINADO_PRODUTOR
    else if (antecipacao.controles_status_associacao !== STATUS.NOVO) {
        if (antecipacao.controles_status_associacao === STATUS.APROVADO)
            return STATUS_ANTECIPACAO.CONTROLE_APROVADO_AIBA
        return STATUS_ANTECIPACAO.CONTROLE_REPROVADO_AIBA
    } else if (antecipacao.controles_doc)
        return STATUS_ANTECIPACAO.CONTROLE_CADASTRADO_RT
    else if (antecipacao.requerimento_status !== STATUS.NOVO) {
        if (antecipacao.requerimento_status === STATUS.APROVADO)
            return STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA
        return STATUS_ANTECIPACAO.PLANTIO_REPROVADO_AIBA
    } else if (antecipacao.aprovacao_rt_status !== STATUS.NOVO) {
        if (antecipacao.aprovacao_rt_status === STATUS.APROVADO)
            return STATUS_ANTECIPACAO.PLANTIO_APROVADO_RT
        return STATUS_ANTECIPACAO.PLANTIO_REPROVADO_RT
    } else if (antecipacao.aprovacao_rt) {
        return STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR
    }
    return STATUS_ANTECIPACAO.CRIADO
}

export const labelEstado = (antecipacao: PlanoType) => {
    switch (estado(antecipacao)) {
        case STATUS_ANTECIPACAO.CRIADO: return 'Criado'
        case STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR: return 'Plantio Cadastrado'
        case STATUS_ANTECIPACAO.PLANTIO_APROVADO_RT: return 'Aprovado RT'
        case STATUS_ANTECIPACAO.PLANTIO_REPROVADO_RT: return 'Reprovado RT'
        case STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA: return 'Plantio Aprovado AIBA'
        case STATUS_ANTECIPACAO.PLANTIO_REPROVADO_AIBA: return 'Plantio Reprovado AIBA'
        case STATUS_ANTECIPACAO.CONTROLE_CADASTRADO_RT: return 'Controle Cadastrado'
        case STATUS_ANTECIPACAO.CONTROLE_APROVADO_AIBA: return 'Controle Aprovado AIBA'
        case STATUS_ANTECIPACAO.CONTROLE_REPROVADO_AIBA: return 'Controle Reprovado AIBA'
        case STATUS_ANTECIPACAO.CONTROLE_ASSINADO_PRODUTOR: return 'Assinado Produtor'
        case STATUS_ANTECIPACAO.PLANO_APROVADO_ADAB: return 'Aprovado ADAB'
        case STATUS_ANTECIPACAO.PLANO_REPROVADO_ADAB: return 'Reprovado ADAB'
        default: return ''
    }
}

export const labelEstadoCompleto = (antecipacao: PlanoType) => {
    switch (estado(antecipacao)) {
        case STATUS_ANTECIPACAO.CRIADO: return 'Antecipação criada, aguardando cadastro de plantio pelo Produtor.'
        case STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR: return 'Plantio Cadastrado pelo Produtor, aguardando aprovação do Responsável Técnico'
        case STATUS_ANTECIPACAO.PLANTIO_APROVADO_RT: return 'Plantio aprovado pelo Responsável Técnico, aguardando aprovação da associação AIBA'
        case STATUS_ANTECIPACAO.PLANTIO_REPROVADO_RT: return 'Plantio reprovado pelo Responsável Técnico, criar nova antecipação.'
        case STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA: return 'Plantio aprovado pela associação AIBA, aguardando cadastro de plano de controle pelo Responsável Técnico'
        case STATUS_ANTECIPACAO.PLANTIO_REPROVADO_AIBA: return 'Plantio reprovado pela associação AIBA'
        case STATUS_ANTECIPACAO.CONTROLE_CADASTRADO_RT: return 'Plano de controle cadastrado pelo Responsável Técnico'
        case STATUS_ANTECIPACAO.CONTROLE_APROVADO_AIBA: return 'Plano de controle aprovado AIBA pela associação AIBA'
        case STATUS_ANTECIPACAO.CONTROLE_REPROVADO_AIBA: return 'Plano de controle reprovado AIBA pela associação AIBA'
        case STATUS_ANTECIPACAO.CONTROLE_ASSINADO_PRODUTOR: return 'Termo e Plano assinados pelo Produtor'
        case STATUS_ANTECIPACAO.PLANO_APROVADO_ADAB: return 'Termo e Plano aprovados e assinados pela agência ADAB'
        case STATUS_ANTECIPACAO.PLANO_REPROVADO_ADAB: return 'Antecipação reprovada pela agência ADAB'
        default: return ''
    }
}

const labelPlantio = (antecipacao: PlanoType) => {
    const status = estado(antecipacao)
    switch (status) {
        case STATUS_ANTECIPACAO.CRIADO:
            return 'Aguardando cadastro pelo Produtor'
        case STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR:
            return 'Aguardando aprovação do Responsável Técnico'
        case STATUS_ANTECIPACAO.PLANTIO_APROVADO_RT:
            return 'Aguardando aprovação da Associação (AIBA)'
        case STATUS_ANTECIPACAO.PLANTIO_REPROVADO_RT:
            return 'Plantio reprovado pelo Responsável Técnico'
        case STATUS_ANTECIPACAO.PLANTIO_REPROVADO_AIBA:
            return 'Plantio reprovado pela Associação (AIBA)'
        default:
            return ''

    }
}
const enablePlantio = (antecipacao: PlanoType) => {
    return true
}
const labelControles = (antecipacao: PlanoType) => {
    const status = estado(antecipacao)
    switch (status) {
        case STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA:
            return 'Aguardando cadastro dos controles pelo RT'
        case STATUS_ANTECIPACAO.CONTROLE_CADASTRADO_RT:
            return 'Aguardando aprovação da Associação (AIBA)'
        case STATUS_ANTECIPACAO.CONTROLE_REPROVADO_AIBA:
            return 'Controle reprovado pela Associação (AIBA)'
        default:
            return ''
    }
}
const enableControle = (antecipacao: PlanoType) => {
    return true
}
const labelTermo = (antecipacao: PlanoType) => {
    const status = estado(antecipacao)
    switch (status) {
        case STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA:
            return 'Agurdando assinatura do Produtor'
        case STATUS_ANTECIPACAO.CONTROLE_ASSINADO_PRODUTOR:
            return 'Aguardando aprovação da Agência (ADAB)'
        case STATUS_ANTECIPACAO.PLANO_APROVADO_ADAB:
            return 'Termo aprovado e assinado pela Agência (ADAB)'
        default:
            return ''
    }
}
const enableTermo = (antecipacao: PlanoType) => {
    return true
}
const labelPlano = (antecipacao: PlanoType) => {
    const status = estado(antecipacao)
    switch (status) {
        case STATUS_ANTECIPACAO.CONTROLE_CADASTRADO_RT:
            return 'Aguardando assinatura da Associação (AIBA)'
        case STATUS_ANTECIPACAO.CONTROLE_APROVADO_AIBA:
            return 'Aguardando assinatura do Produtor'
        case STATUS_ANTECIPACAO.PLANO_APROVADO_ADAB:
            return 'Plano aprovado e assinado pela Agência (ADAB)'
    }
}
const enablePlano = (antecipacao: PlanoType) => {
    return true
}
const CardAntecipacao = (props: AntecipacaoProps) => {
    const [showPlantio, setShowPlantio] = useState(false)
    console.log('CardAntecipacao', props.antecipacao?.propriedade)
    return (
        props.antecipacao ?
            <>
                <div>
                    <div>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Imóvel</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Safra</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Status</th>
                            <tr>
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{props.antecipacao.propriedade.nome} </td>
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{props.antecipacao.safra.periodo} </td>
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{labelEstadoCompleto(props.antecipacao)}</td>
                            </tr>
                        </table>

                    </div>
                </div>
                <CadastroPlantio visible={showPlantio} setVisible={setShowPlantio}
                    propriedades={[props.antecipacao.propriedade]} propriedade={props.antecipacao.propriedade}
                    config={CadastroPlantioConfig.CADASTRO_PRODUTOR} plano={props.antecipacao}
                />
                <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '20px', marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Button
                            label="Plantio" className="p-button-raised p-button-text"
                            style={{ width: '150px', height: '100px' }}
                            onClick={() => setShowPlantio(true)} />
                        <div style={{ fontSize: 10, width: 150, textAlign: 'center' }}>
                            {labelPlantio(props.antecipacao)}
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Button
                            label='Controles' className="p-button-raised p-button-text"
                            style={{ width: '150px', height: '100px' }} />
                        <div style={{ fontSize: 10, width: 150, textAlign: 'center' }}>
                            {labelControles(props.antecipacao)}
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Button label="Termo" className="p-button-raised p-button-text"
                            style={{ width: '150px', height: '100px' }} />
                        <div style={{ fontSize: 10, width: 150, textAlign: 'center' }}>
                            {labelTermo(props.antecipacao)}
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Button
                            label="Plano de Trabalho" className="p-button-raised p-button-text"
                            style={{ width: '150px', height: '100px' }} />
                        <div style={{ fontSize: 10, width: 150, textAlign: 'center' }}>
                            {labelTermo(props.antecipacao)}
                        </div>
                    </div>
                </div>
            </>
            :
            <div>
                Selecione uma antecipação
            </div>

    )
}
export default CardAntecipacao;